import React from 'react';
import { Sun, Sunset, Moon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: Sun,
    title: 'Por la Mañana',
    desc: 'Una pausa breve para establecer la intención de tu día y comenzar con calma.'
  }, {
    icon: Sunset,
    title: 'Por la Tarde',
    desc: 'Una afirmación poderosa para re-centrarte en medio de la actividad diaria.'
  }, {
    icon: Moon,
    title: 'Antes de Dormir',
    desc: 'Una micro-pausa para soltar las cargas del día y descansar profundamente.'
  }];
  return <section className="py-20 bg-[#f5f1e8]" data-id="element-121">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <div className="text-center mb-16" data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1a3a52] mb-4" data-id="element-124">
            Tu Viaje de 30 Días
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-125">
            Pequeños momentos de calma que, juntos, deshacen el nudo de la
            ansiedad día tras día.
          </p>
        </div>

        <div className="relative" data-id="element-126">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-[#d4af37]/30 -z-10" data-id="element-127"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-128">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-129">
                <div className="w-24 h-24 bg-white rounded-full border-4 border-[#f5f1e8] shadow-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-130">
                  <step.icon className="w-10 h-10 text-[#d4af37]" data-id="element-131" />
                </div>
                <h3 className="text-xl font-serif font-bold text-[#1a3a52] mb-3" data-id="element-132">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-133">{step.desc}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}